import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import navigation from './navigation';
import search from './search-form';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
    navigation();
    search();

    const countrySelect = document.querySelectorAll('.js-country-select');
    if (countrySelect.length > 0) {
        countrySelect.forEach((container) => {
            const button = container.querySelector('button');

            // Toggle on button click
            button.addEventListener('click', () => {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', !isExpanded);
                container.classList.toggle('is-open');
            });

            // Close on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && container.classList.contains('is-open')) {
                    button.setAttribute('aria-expanded', 'false');
                    container.classList.remove('is-open');
                    button.focus();
                }
            });

            // Close on click outside
            document.addEventListener('click', (e) => {
                if (!container.contains(e.target) && container.classList.contains('is-open')) {
                    button.setAttribute('aria-expanded', 'false');
                    container.classList.remove('is-open');
                }
            });
        });
    }

    const header = document.querySelector('.js-header');
    if (header) {
        gsap.timeline({
            scrollTrigger: {
                trigger: '.js-page',
                start: 'top -100px',
                end: 99999,
                toggleActions: 'play none none reverse',
                toggleClass: {
                    targets: header,
                    className: 'is-scrolled',
                },
            },
        });
    }
};

export default init;
